let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("ffQaD"), load("kvRbA"), load("bboUq")]).then(() => parcelRequire('5LuJb'));